module.exports = __webpack_public_path__ + "img/ppt.0e97c564.svg";